import script from "./Documents.vue?vue&type=script&setup=true&lang=js"
export * from "./Documents.vue?vue&type=script&setup=true&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=e2e60bae&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2e60bae"]])

export default __exports__